import { trigger, transition, style, animate } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: 'app-cookies-notification',
  templateUrl: './cookies-notification.component.html',
  styleUrls: ['./cookies-notification.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1000, style({ opacity: 1 }))
      ]),
      transition('* => void', [
        animate(1000, style({ opacity: 0 }))
      ])
    ])
  ]
})

export class CookiesNotificationComponent implements OnInit {
  domain: string;
  localCookieConsent: boolean;
  remoteCookieConsent: boolean;

  constructor(
    private cookieService: CookieService,
  ) { }

  ngOnInit(): void {
    this.domain = this.getDomain();
    this.localCookieConsent = this.getLocalCookiesConsent();
    this.remoteCookieConsent = this.getCaelPortalConsent();
  }

  getLocalCookiesConsent(): boolean {
    return this.cookieService.get("nor_privacy_cookies_bar_closed") === "1";
  }

  getCaelPortalConsent(): boolean {
    return this.cookieService.get("cael_gdpr_bar_closed") === "1";
  }

  getDomain(): string {
    const hostname = window.location.hostname;
    const tempSplit = hostname.split(".");
    const domain = tempSplit[tempSplit.length - 2] + "." + tempSplit[tempSplit.length - 1];

    return domain;
  }


  consent() {
    this.localCookieConsent = true;
    this.cookieService.set("nor_privacy_cookies_bar_closed", "1", { path: "/", secure: true, expires: 7, domain: this.domain });
  }

}
